/* eslint-disable max-len */
const faq = `

<div class="accordion-wrapper">

<div class="left">

<div class="accordion">
<input type="checkbox" id="chck1">
<label class="accordion-label" for="chck1">Bagaimana cara melakukan pembayaran?</label>
<div class="accordion-content">
<p>
Pembayaran pinjaman dapat dilakukan melalui ATM, Internet Banking dan Mobile Banking dengan menggunakan kode pembayaran Virtual Account (VA), melalui Bank BCA, Bank BRI, Bank BNI, Bank Mandiri dan pembayaran menggunakan e-wallet dapat menggunakan ShopeePay dan OVO, atau pembayaran secara tunai dengan menggunakan kode pembayaran Alfamart.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck2">
<label class="accordion-label" for="chck2">Masa berlaku kode pembayaran atau VA</label>
<div class="accordion-content">
<p>
Kode pembayaran atau VA dapat dicek pada aplikasi Easycash, pastikan kode itu sesuai dengan aplikasi Easycash.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck3">
<label class="accordion-label" for="chck3">Informasi denda keterlambatan</label>
<div class="accordion-content">
<p>
Denda keterlambatan per hari adalah sebesar {2} + bunga harian Anda. Untuk informasi denda keterlambatan ini dapat dilihat melalui aplikasi Easycash.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck4">
<label class="accordion-label" for="chck4">Apa yang terjadi jika saya tidak membayar tagihan?</label>
<div class="accordion-content">
<p>
Pastikan pembayaran dapat dilakukan maksimal pada tanggal jatuh tempo yang tertera di aplikasi Easycash. Jika terjadi keterlambatan, nantinya Anda akan secara rutin dihubungi tim penagihan kami. Untuk biaya keterlambatan akan diberikan sesuai kebijakan yang berlaku di aplikasi Easycash.
</p>
</div>
</div>

</div>

<div class="right">

<div class="accordion">
<input type="checkbox" id="chck5">
<label class="accordion-label" for="chck5">Apakah saya dapat melakukan pelunasan di awal pinjaman?</label>
<div class="accordion-content">
<p>
Anda dapat melakukan pelunasan lebih awal tetapi tidak ada potongan biaya atau bunga.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck6">
<label class="accordion-label" for="chck6">Permintaan perpanjangan tenor pinjaman Easycash</label>
<div class="accordion-content">
<p>
Untuk saat ini tidak tersedia perpanjangan masa tenor. Jika pembayaran dilakukan melewati batas waktu pada aplikasi, maka Anda akan dikenakan denda keterlambatan.
</p>
</div>
</div>

<div class="accordion">
<input type="checkbox" id="chck7">
<label class="accordion-label" for="chck7">Masalah pembayaran yang belum terkonfirmasi</label>
<div class="accordion-content">
<p>
Perihal pembayaran Anda, mohon kesediaannya menunggu 1 x 24 jam. Jika dalam waktu tersebut belum ada perubahan pada aplikasi Easycash, silakan Anda menghubungi Layanan Pelanggan Easycash dengan melampirkan bukti pembayaran lewat email: <a href="mailto: cs.pinjaman@easycash.id">cs.pinjaman@easycash.id</a>, live chat pada aplikasi Easycash, atau hubungi Call Center <a href="tel:1500866">1500866</a>.
</p>
</div>
</div>

</div>

</div>

`;

export default faq;
